"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckContainerReefer = function SvgIconTruckContainerReefer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck container reefer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Container Reefer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 9v30.154h38V9H5zm8.041 4.133h-2.01v22h2.01v-22zm24.123 0h-2.01v22h2.01v-22zm-7.543 10.074l2.293-2.293A.999.999 0 1030.5 19.5l-3.707 3.707h-1.69v-1.793l3.708-3.707a1 1 0 00-1.415-1.414l-2.293 2.293V15a1 1 0 10-2 0v3.586l-2.292-2.293a1 1 0 10-1.415 1.414l3.707 3.707v1.793h-1.689L17.707 19.5a.999.999 0 10-1.414 1.414l2.293 2.293.971 1-.971 1-2.293 2.293a.999.999 0 101.414 1.414l3.707-3.707h1.689V27l-3.707 3.707a1 1 0 001.415 1.414l2.292-2.293v3.586a1 1 0 002 0v-3.586l2.293 2.293a1 1 0 101.415-1.414L25.103 27v-1.793h1.69l3.707 3.707a.999.999 0 101.414-1.414l-2.293-2.293-.99-1 .99-1z"
  }));
};

var _default = SvgIconTruckContainerReefer;
exports.default = _default;